import CartTotal from "components/Cart/CartTotal"
import React, {Component} from "react"
 //ELEM REACT16 CHANGE
import {Button, Form, Icon, Modal, Image, Table} from "semantic-ui-react"
import {Link} from "react-router-dom"
import {observer} from "mobx-react"

import shop from "shop/shop"
import Typeahead from "components/Typeahead/Typeahead"
import QuickorderTable from "components/Quickorder/QuickorderTable"
import _ from "lodash"
import CSV from "components/CSV/CSV"

@observer
export default class QuickorderPage extends Component {

	state = {
		products : [],
		product  : false,
		count    : 0,
		searchKey: 0
	}

	componentDidMount() {
		shop.cart.hooks.changed.add( this.updateCart )
		this.setState( {
			sum: shop.cart.sum
		} )
	}

	componentWillUnmount() {
		shop.cart.hooks.changed.remove( this.updateCart )
	}

	updateCart = ( {cart} ) => {
		this.setState( {
			sum: cart.sum
		} )
	}

	handleRemoveProduct = ( productToRemove ) => {
		shop.cart.remove( productToRemove )
	}

	handleSelect = ( {product} ) => {
		console.log( `product`, product )
		if ( !product.price ) {
			shop.toast( `Produkt nicht erhältlich: ${product.title} ist nicht zum Kauf verfügbar`, "warning", false, "bottom" )
			return
		}
		product.count = 0
		product.visible = false

		window.setTimeout( () => {
			this.focusByQuerySelector( "#number-input" )
		}, 30 )

		!this.props.skipProductSelection && this.setState( {product} )
	}

	focusByQuerySelector = selector => {
		let el = document.querySelector( selector )
		if ( el ) el.focus()
	}

	resetForm = () => {
		console.log( "RESET FORM" )
		let product = this.state.product
		if ( !product ) return
		product.count = product.count || 1
		shop.cart.add( product )
		this.setState( {products: [...this.state.products, product], count: "", searchKey: this.state.searchKey + 1} )

		window.setTimeout( () => {
			this.focusByQuerySelector( "#typeahead-input" )
		}, 250 )
	}

	handleKeys = ( e ) => {
		const CHAR_ENTER = 13

		if ( e.charCode === CHAR_ENTER ) {
			this.resetForm()
			e.preventDefault()
			return false
		}
	}

	render() {
		const {product, value, searchKey} = this.state
		const {productsById, ready} = shop.cart
		if ( !ready ) return null
		return (
			<div className="container pt4 pb5">
				<h1 className="page-title"><i className="icon-sort-alt-up icon-lg" /><strong>{translate( "Quickorder" )}</strong></h1>
				<tr>
					<td sm="1" md="3/4">
						<p>{translate( "QUICKORDER_NOTICE" )}</p>
					</td>
					{!shop.config.hideimport && <td sm="1" md="1/4">
						<h2>{translate( "Produkte importieren" )}</h2>
						<ProductImporter />
					</td>}
				</tr>

				<section>
					<div className="row-title"><h2>{translate( "cart.cart" )}</h2></div>
					<QuickorderTable handleRemoveProduct={this.handleRemoveProduct} products={productsById}
									 onChange={( {product} ) => {
										 shop.cart.add( product )
									 }} />
				</section>

				<section className={"cf pb3"}>
					<div className="fr">
						<CartTotal />
					</div>
				</section>
				
				{/*TYPEAHEAD*/}
				<section className="pb2 pt3">
					<Form onSubmit={this.resetForm}>
						<tr>
							<td sm="1/2">
								<label htmlFor="">{translate( "add article" )}</label>
								<Typeahead key={searchKey} onSelectProduct={this.handleSelect} {... this.resetForm}/>
								{/*<Typeahead
									count={42} // TODO: THIS IS FOR HOTEX
									key={searchKey}
									artnr={0}
									onSelectProduct={this.handleSelect}
									fluid
									// onSelect={this.handleSelect}
									value={this.state.value}{... console.log("value: ",value)}
									placeholder={translate("Art.-Nr.")}
									onChange={( value ) => this.setState( {value} ) }{... console.log("STATEVALUE: ", this.state.value)}
								/>*/}
							</td>
							<td sm="1/4">
								<label htmlFor="">{translate( "PU" )}: {/*product.unit_desc*/}</label>
								<Form.Input
									type="number"
									id="number-input"
									disabled={!product}
									onFocus={() => {
										this.setState( {count: ""} )
									}}
									onKeyDown={this.handleKeys}
									onKeyUp={this.handleKeys}
									onChange={( e ) => {
										if ( !product ) return
										product.count = Number( e.target.value )
										this.setState( {count: product.count} )
										// shop.cart.add( product )
									}}
									value={this.state.count}
									placeholder="1" />
							</td>
							<td sm="1/4">
								<label htmlFor="">&nbsp;</label>
								<div><Button primary floated="right">{translate( "in den Warenkorb" )}</Button></div>
							</td>
						</tr>
					</Form>
				</section>

				<hr />
				<div className="fr pt5">
					<Link to="/"> <Button basic> <i className="icon-angle-left" />{translate( "continue shopping" )}</Button></Link>
					<Link to="/checkout"> <Button primary>{translate( "checkout" )}<i className="icon-angle-right" /> </Button></Link>
				</div>

			</div>
		)
	}
}

class ProductImporter extends Component {

	state = {
		open: false
	}

	render() {
		const {open} = this.state
		return (
			<div>
				<Button basic fluid onClick={() => this.setState( {open: true} )}>{translate( "import" )}</Button>
				<Modal
					closeIcon={<Icon name="close" />}
					open={open}
					onClose={() => {
						this.setState( {open: false} )
					}}
					size="tiny"
				>
					<Modal.Header>{translate( "import products" )}</Modal.Header>
					<Modal.Content>
						<CSV onResult={( {products} ) => {
							_.each( products, (product => {
									shop.cart.add( product )
								})
							)
							shop.toast( translate( "products successfully imported" ) )
							this.setState( {open: false} )
						}
						} />
					</Modal.Content>

					<div className="bg-silver pa4">
						<p>{translate( "UPLOAD_NOTIFICATION" )}<a
							download={`Bestellvorlage.csv`}
							href="/Bestellvorlage.csv">{`Bestellvorlage.csv`}</a>.</p>
						<p>{translate( "Die Daten müssen, wie in der Bestellvorlage.csv vorgegeben, wie folgt abgelegt werden: " )}<br/></p>
						<Table>
							<tr>
								<td>Vorgabe</td>
								<td>ARTIKELNUMMER,MENGE</td>
							</tr>
							<tr>
								<td>Beispiel</td>
								<td>9801190-KF07-090/200,2</td>
							</tr>
						</Table>
					</div>
					<div className="bg-silver pa4">
						<p>{translate( "Beispieldarstellung in Excel: " )}</p>
						<Image src="/../bestellvorlageBSP.PNG"></Image>
					</div>

					{/*<Modal.Actions>*/}
					{/*/!*<Button positive icon="checkmark" labelPosition="right" content="Yes" />*!/*/}
					{/*</Modal.Actions>*/}
				</Modal>
			</div>

		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/lindt/pages/quickorder/QuickorderPage.js